import { render, staticRenderFns } from "./callAssignment.vue?vue&type=template&id=80f88db4"
import script from "./callAssignment.vue?vue&type=script&lang=js"
export * from "./callAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports